import styled from 'styled-components';
import { lighten, darken } from 'polished';

export const Container = styled.div`
  padding: 0;
  margin: 0;
`;

export const CheckBoxWrapper = styled.div`
  position: relative;
  /* flex: 1 1; */
  align-self: left;
  cursor: pointer;

  > div {
    width: 60px;
    align-self: center;
    padding: 0;
    margin: 0;
    svg {
      height: 24px;
    }
  }
`;
export const CheckBoxLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 60px;
  height: 26px;
  border-radius: 15px;
  background: ${props => props.theme.switch.background};
  cursor: pointer;
  &::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    margin: 3px;
    background: #ffffff;
    box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
  &:hover::after {
    width: 27px;
  }
`;
export const CheckBox = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 60px;
  height: 26px;
  display: flex;
  &:disabled + ${CheckBoxLabel} {
    cursor: not-allowed;
    background: ${props =>
      props.theme.name === 'dark'
        ? lighten(0.05, props.theme.cardBackgroud)
        : darken(0.08, props.theme.cardBackgroud)};
    &::after {
      opacity: 0.8;
    }
    &:hover::after {
      width: 18px;
    }
  }
  &:checked + ${CheckBoxLabel} {
    background: ${props => props.theme.success}; /*#4fbe79;*/

    &::after {
      content: '';
      display: block;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      margin-left: 39px;
      transition: 0.2s;
    }
    &:hover::after {
      width: 25px !important;
      margin-left: 31px;
    }
  }

  &:hover {
    /* width: fit-content; */
    flex: 1 1;
  }
`;
